/**
 *
 * Asynchronously loads the component for PublicProfilePage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PublicProfilePage = lazyLoad(
  () => import('./index'),
  module => module.PublicProfilePage,
);
